import React from "react";
import {connect} from "react-redux";
import {FixedDropDownButton, Icon, modal, utils, commons, Loader, ff} from "@mc/mc-legacy";
import GroupMenu from "../components/GroupMenu";
import CustomPageLayout from "./CustomPageLayout";
import * as actions from "../actions/pozadavkyNevyrizeneActions";
import * as pdfViewerActions from "../actions/pdfViewerActions";
import {Col, DropdownItem, Row} from "reactstrap";
import {getStatusIcon} from "../components/StatusBar";
import SignRequestInfoData from "../components/SignRequestInfoData";
import SignRequestTitle from "../components/SignRequestTitle";
import signRequestInternalApi from "../api/gen/qsign/SignRequestInternalApi";
import * as groupMenuActions from "../actions/groupMenuActions";
import ChangeSignPersonForm from "../components/forms/ChangeSignPersonForm";
import * as pozadavkyActions from "../actions/pozadavkyActions";
import EnumState from "../api/gen/qsign/types/EnumState";
import Type from "../api/gen/qsign/types/Type";
import MessageEmptyList from "../components/MessageEmptyList";
import PodepisovaniPdfViewer from "../components/PodepisovaniPdfViewer";
import "./CustomItem.scss";
import ItemListFixed from "../components/ItemListFixed";

const {sinkEvent} = commons;
import ActionCountIcon from "../components/ActionCountIcon";
import QSignPracovnikApi from "../api/gen/qsign/QSignPracovnikApi";
import ChangeApproversForm from "../components/forms/ChangeApproversForm";
import PrilohyButton from "../components/PrilohyButton";
import * as pracovniciActions from "../actions/pracovniciActions";

/**
 * Nevyřízené požadavky page.
 */
class PozadavkyNevyrizenePage extends React.Component {
    componentDidMount() {
        this.fetchData(this.props, true);
        this.handleFilter();
    }

    handleFilter() {
        const {filterList} = this.props;
        this.props.dispatch(pozadavkyActions.filter({...filterList.filter, stateList: [EnumState.INIT]}));
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.fetchData(nextProps, false);
    }

    fetchData = (props, forceFetch) => {
        const {dispatch, selectedPracovnikToFilter} = props;
        let puvodniPracovnik = this.props.selectedPracovnikToFilter.data;
        if (selectedPracovnikToFilter.data) { // Pouze pokud je podepisující/schvalovatel vybrán
            const pracovnikId = selectedPracovnikToFilter.data.id;
            if (pracovnikId !== (puvodniPracovnik && puvodniPracovnik.id)) { // Pouze pokud se liší od původně vybraného
                dispatch(actions.fetchPodepisujiciSchvalovatel(pracovnikId, true));
            }
        } else {
            if (puvodniPracovnik && puvodniPracovnik.id) {
                dispatch(actions.fetchPodepisujiciSchvalovatel(null, true));
            }
            dispatch(actions.fetchIfNeeded(forceFetch));
        }

        if (forceFetch) {
            dispatch(groupMenuActions.invalidate());
        }
    };
    handleChangeSignPerson = (signRequest) => {
        const { dispatch } = this.props;
        dispatch(
            modal.ModalActions.showAsyncWaiting(
                "Načítání změny podepisujících",
                <Loader />,
                Promise.all([QSignPracovnikApi.findAllActive(), QSignPracovnikApi.findRequestSigners(signRequest.id)]),
                ([signers, podepisujici]) => {
                    const {dispatch} = this.props;
                    const pracovniciIds = podepisujici.map(value => value.pracovnik.id);

                    const pracovniciActive = {};

                    podepisujici.forEach(value => {
                        pracovniciActive[value.pracovnik.id] = value.signed;
                    });

                    dispatch(
                        modal.ModalActions.show(
                            ChangeSignPersonForm,
                            {
                                onSubmit: (data) => {
                                    const {pracovnici} = data;
                                    return signRequestInternalApi.changeSignPerson(signRequest.id, {pracovnikIds: pracovnici});
                                },
                                onSubmitSuccess: (result, dispatch) => {
                                    dispatch(modal.ModalActions.hide());
                                    this.fetchData(this.props, true);
                                },
                                pracovniciActive: pracovniciActive,
                                initialValues: {
                                    pracovnici: pracovniciIds,
                                    allSigners: signers,
                                },
                            },
                            "Změna podepisujícího"
                        )
                    );
                }
            )
        );
    };
    handleChangeApprovers = (signRequest) => {
        const { dispatch } = this.props;
        dispatch(
            modal.ModalActions.showAsyncWaiting(
                "Načítání změny schvalujících",
                <Loader />,
                Promise.all([QSignPracovnikApi.findAllActive(), QSignPracovnikApi.findRequestApproval(signRequest.id)]),
                ([pracovnici, schvalujici]) => {
                    const pracovniciTransform = pracovnici.map(p => ({
                        id: p.id,
                        name: `${p.uplneJmeno} (${p.organizacniJednotka.kod})`,
                        title: p.organizacniJednotka.nazev
                    }));

                    dispatch(
                        modal.ModalActions.show(
                            ChangeApproversForm,
                            {
                                onSubmit: (data) => {
                                    return signRequestInternalApi.changeApproval(signRequest.id, data);
                                },
                                onSubmitSuccess: (result, dispatch) => {
                                    dispatch(modal.ModalActions.hide());
                                    this.fetchData(this.props, true);
                                },
                                initialValues: {
                                    steps: schvalujici.steps
                                },
                                pracovnici: pracovniciTransform,
                            },
                            "Změna schvalujících"
                        )
                    );
                }
            )
        );
    };
    handleZobrazit = (signRequest, type, viewMode) => {
        this.props.dispatch(
            pdfViewerActions.showDocuments(
                signRequest,
                false,
                type,
                () => {
                    this.fetchData(this.props, true);
                },
                viewMode
            )
        );
    };
    handleStorno = (signRequest) => {
        const {dispatch} = this.props;
        dispatch(
            modal.ModalActions.showConfirm(
                "Potvrzení stornování",
                "Opravdu chcete stornovat požadavek?",
                () =>
                    signRequestInternalApi.stornoSignRequest(signRequest.id).then(() => {
                        this.fetchData(this.props, true);
                    }),
                null,
                "Stornovat"
            )
        );
    };
    checkClickActive = (count, callback, ...params) => {
        return count > 0 ? () => callback(...params) : null;
    };
    renderItem = (item: SignRequestWithCountsVO) => {
        const statusItems = [
            {
                status: "total",
                count: item.totalDocuments,
                title: "Dokumentů v požadavku: " + item.totalDocuments,
                onClick: this.checkClickActive(
                    item.totalDocuments,
                    this.handleZobrazit,
                    item,
                    Type.ALL,
                    PodepisovaniPdfViewer.VIEW_MODE.BASE
                ),
            },
            {
                status: "signed",
                count: item.signedDocuments,
                title: "Podepsaných dokumentů: " + item.signedDocuments,
                onClick: this.checkClickActive(
                    item.signedDocuments,
                    this.handleZobrazit,
                    item,
                    Type.SIGNED,
                    PodepisovaniPdfViewer.VIEW_MODE.BASE
                ),
            },
            {
                status: "rejected",
                count: item.rejectedDocuments,
                title: "Odmítnutých dokumentů: " + item.rejectedDocuments,
                onClick: this.checkClickActive(
                    item.rejectedDocuments,
                    this.handleZobrazit,
                    item,
                    Type.REJECTED,
                    PodepisovaniPdfViewer.VIEW_MODE.BASE
                ),
            },
            {
                status: "waiting",
                count: item.waitingDocuments,
                title: "Nevyřízených dokumentů: " + item.waitingDocuments,
                onClick: this.checkClickActive(
                    item.waitingDocuments,
                    this.handleZobrazit,
                    item,
                    Type.WAITING,
                    PodepisovaniPdfViewer.VIEW_MODE.BASE
                ),
            },
        ];
        return (
            <div className="custom-item">
                <div className="custom-item-content">
                    <Row noGutters className="ml-3">
                        <Col xs={12}>
                            <SignRequestTitle
                                onClick={() => this.handleZobrazit(item, null, PodepisovaniPdfViewer.VIEW_MODE.BASE)}
                                signRequest={item}
                                customRender={(item) => {
                                    if (item.attachmentCount > 0) {
                                        return <PrilohyButton attachmentCount={item.attachmentCount} itemID={item.id}/>;
                                    }
                                }}
                            />
                        </Col>
                        <Col>
                            <SignRequestInfoData showDeadlineExpired signRequest={item}/>
                        </Col>
                    </Row>
                </div>
                <div className="custom-item-action">
                    {statusItems.map((value, key) => {
                        const icon = getStatusIcon(value.status);
                        return (
                            <ActionCountIcon
                                key={key}
                                onClick={value.onClick}
                                title={value.title}
                                icon={icon.icon}
                                color={icon.color}
                                count={value.count}
                            />
                        );
                    })}
                    {this.renderActions(item)}
                </div>
            </div>
        );
    };
    renderActions = (item) => {
        return (
            <div className="actions actions-button">
                <FixedDropDownButton
                    onClick={sinkEvent}
                    color="action"
                    noCaret
                    title={<Icon icon="ellipsis-v" className="action-ellipsis"/>}
                >
                    <DropdownItem key="0"
                                  onClick={() => this.handleZobrazit(item, null, PodepisovaniPdfViewer.VIEW_MODE.BASE)}>
                        Zobrazit požadavek
                    </DropdownItem>
                    {item.waitingDocuments > 0 && (
                        <DropdownItem key="1" onClick={() => this.handleStorno(item)}>
                            Stornovat požadavek
                        </DropdownItem>
                    )}
                    {item.waitingDocuments > 0 && item.pracovnikSignList && item.pracovnikSignList.length > 0 && (
                        <DropdownItem key="2" onClick={() => this.handleChangeSignPerson(item)}>
                            Změnit podepisující
                        </DropdownItem>
                    )}
                    {item.step != null && (
                        <DropdownItem key="3" onClick={() => this.handleChangeApprovers(item)}>
                            Změnit schvalující
                        </DropdownItem>
                    )}
                </FixedDropDownButton>
            </div>
        );
    };

    render() {
        const {itemList} = this.props;

        // if (selectedPracovnikToFilter.data !== null) {
        //     actions.invalidate()
        //     this.fetchPodepisujiciSchvalovatel(selectedPracovnikToFilter.data.id);
        // }

        const listProps = {
            itemList,
            loadMore: actions.loadMore,
            invalidatePozadavky: actions.invalidate,
            renderItem: this.renderItem,
            emptyList: (
                <MessageEmptyList>
                    <div className="message">
                        Žádné nevyřízené požadavky
                        <div className="thumbup">
                            <Icon icon="thumbs-o-up fa-4x"/>
                        </div>
                    </div>
                </MessageEmptyList>
            ),
        };
        return (
            <CustomPageLayout
                header
                searchUserField={true}
                onCloseAction={() => this.fetchData(this.props, true)}
                title="Nevyřízené požadavky"
                menu={<GroupMenu/>}
            >
                <ItemListFixed {...listProps} />
            </CustomPageLayout>
        );
    }
}

function mapStateToProps(state) {
    return {
        selectedPracovnikToFilter: utils.storeFromArea(state, pracovniciActions.SELECTED_PRACOVNIK_TO_FILTER),
        itemList: utils.storeFromArea(state, actions.POZADAVEK_NEVYRIZENE_LIST),
        filterList: utils.storeFromArea(state, pozadavkyActions.POZADAVKY_SEARCH_LIST),
    };
}

export default connect(mapStateToProps)(PozadavkyNevyrizenePage);
